import { stripNonNumeric } from '../../utils/stringUtils';
import {
  TICKET_CRM,
  CONFIG,
  MODULES,
  UNIT,
  ROLES,
  USER,
} from '../../utils/constants';
import requestService from '../../services/request';
import enums from '../../utils/enums';
import logTrace from '../../services/logTrace';
export default {
  state: {
    ticketCrmToken: null,
    tickets: TICKET_CRM.DEFAULT_SUPPORT_ITEMS,
    hasNewTicket: false,
    loading: false,
    error: null,
    listTicketsPromise: null,
    listTicketsPromiseBody: null,
  },
  getters: {
    [TICKET_CRM.GET_ENABLED]: (_state, getters) =>
      !getters[CONFIG.GET_NAVIGATION_RULES].excludeModules.some((module) => {
        return module === MODULES.TICKET_CRM;
      }),
    [TICKET_CRM.GET_TOKEN]: (state) => state.ticketCrmToken,
    [TICKET_CRM.GET_TICKETS]: (state) => state.tickets,
    [TICKET_CRM.HAS_NEW_TICKET]: (state) => state.hasNewTicket,
  },
  mutations: {
    [TICKET_CRM.SET_TOKEN]: (state, payload) => {
      state.ticketCrmToken = payload;
    },
    [TICKET_CRM.SET_TICKETS]: (state, payload) => {
      state.tickets = payload;
    },
    [TICKET_CRM.NEW_TICKET_CREATED]: (state) => {
      state.hasNewTicket = true;
    },
    [TICKET_CRM.NEW_TICKET_LISTED]: (state) => {
      state.hasNewTicket = false;
    },
  },
  actions: {
    [TICKET_CRM.FETCH_TOKEN]: async ({ state, getters, commit }, unitObj) => {
      try {
        if (!unitObj) {
          unitObj = getters[UNIT.GET_SELECTED];
        }
        const user = getters[USER.GET_USER];
        state.loading = true;
        const body = {
          productSku: unitObj.sku,
          _id: user._id,
          userRole: user.userRole,
        };
        // if (user.userRole === ROLES.CLIENT_ROLE) {
        //   const users = [];

        //   const { proposers } = unitObj.contracts[0];
        //   if (!proposers || proposers.length === 0) {
        //     const url = `${process.env.AUTH_API_URL}/user/getContracts`;
        //     const query = {
        //       username: user.username,
        //       onlyValid: 1,
        //     };
        //     const contracts = await requestService(url, 'GET', {
        //       params: query,
        //     });
        //     commit(UNIT.MUTATE, contracts);
        //   }

        //   for (const contract of unitObj.contracts) {
        //     for (const proposer of contract.proposers) {
        //       const userDocument = stripNonNumeric(proposer.document);
        //       const isLegalEntity = userDocument.length > 11;
        //       const userItem = {
        //         uniqueId: proposer.id,
        //         isLegalEntity,
        //         document: userDocument,
        //       };
        //       if (user.username === stripNonNumeric(proposer.document)) {
        //         users.unshift(userItem);
        //       } else {
        //         users.push(userItem);
        //       }
        //     }
        //   }
        //   body.users = users;
        //   body.userRole = user.userRole;
        // } else if (user.userRole === ROLES.SYNDIC_ROLE) {
        //   body.users = [
        //     { uniqueId: user.email, isLegalEntity, document: user.username },
        //   ];
        //   body.userRole = user.userRole;
        // } else {
        //   return;
        // }
        const url = `${process.env.TICKET_CRM_API_URL}/getToken`;
        const { ticketCrmToken, dateStartVisibledError } = await requestService(
          url,
          'POST',
          {
            data: body,
          }
        ).catch((err) => {
          throw err;
        });
        if (dateStartVisibledError) {
          logTrace({
            action: enums.logTraceActions.bexsServerError,
            details: {
              url,
              dateStartVisibledError,
            },
          });
        }
        commit(TICKET_CRM.SET_TOKEN, ticketCrmToken);
        state.error = null;
        return ticketCrmToken;
      } catch (error) {
        state.error = error;
        throw error;
      } finally {
        state.loading = false;
      }
    },
    [TICKET_CRM.FETCH_TICKET]: async ({ getters, dispatch }, number) => {
      try {
        if (!hasPermission(enums.supportViewProfiles)) return;
        let ticketCrmToken = getters[TICKET_CRM.GET_TOKEN];
        if (!ticketCrmToken)
          ticketCrmToken = await dispatch(TICKET_CRM.FETCH_TOKEN);

        const url = `${process.env.TICKET_CRM_API_URL}/getTicket`;
        return await requestService(url, 'GET', {
          params: {
            ticketCrmToken,
            number,
          },
          localErrorHandling: true,
        });
      } catch (err) {
        throw err;
      }
    },
    [TICKET_CRM.FETCH_PROPOSERS_TICKETS]: async ({
      state,
      getters,
      commit,
    }) => {
      try {
        if (!hasPermission(enums.supportViewProfiles)) return;

        let ticketCrmToken = this.ticketCrmToken;
        if (!ticketCrmToken) {
          ticketCrmToken = await dispatch(TICKET_CRM.FETCH_TOKEN);
          if (!ticketCrmToken) return;
        }

        if (!this.supportItems.lastTicket || this.hasNewTicket) {
          state.loading = true;
        }

        const url = `${process.env.TICKET_CRM_API_URL}/listTickets`;
        const body = {
          ticketCrmToken,
          productSku: this.selectedUnit.sku,
        };

        if (
          state.listTicketsPromise &&
          state.listTicketsPromiseBody.productSku == body.productSku
        ) {
          return;
        }

        for (let retries = 0; retries >= 0; retries--) {
          try {
            state.listTicketsPromise = requestService(url, 'POST', {
              data: body,
            });
            state.listTicketsPromiseBody = body;
            const [result] = await Promise.all([state.listTicketsPromise]);
            if (!result) {
              state.error = true;
            } else {
              retries = 0;
              state.error = null;
              commit(TICKET_CRM.NEW_TICKET_LISTED);
              commit(
                TICKET_CRM.SET_TICKETS,
                result || {
                  ...TICKET_CRM.DEFAULT_SUPPORT_ITEMS,
                }
              );
              state.listTicketsPromise = null;
              state.listTicketsPromiseBody = null;
              break;
            }
          } catch (error) {
            console.error('Retrying TicketCRM list tickets', error);
            if (retries < 1) {
              state.error = error;
            }
            state.listTicketsPromise = null;
            state.listTicketsPromiseBody = null;
          }
        }
        state.loading = false;
      } catch (err) {
        state.error = true;
        state.loading = false;
        throw err;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ticketCrm.js